import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import {
  FadeIn,
  FadeInBottom,
} from "../../design-system/styles/animations.styles"
import Grid from "../shared/grid"
import SectionDivider from "../shared/section-divider"
import {
  Container,
  GridOverlay,
  HeaderContainer,
  HeaderContainerInner,
  MapContainer,
  MapLabel,
  MobileImage,
  SectionTitle,
  TitleDescription,
} from "./client-locations.style"

function ClientLocations() {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "0_HOMEPAGE/World Map/world map.svg" }) {
        id
        relativePath
        publicURL
      }
    }
  `)

  return (
    <Container>
      <SectionDivider />
      <Grid overlayStyle={GridOverlay}>
        <MobileImage src={data.file.publicURL} />
        <HeaderContainer>
          <HeaderContainerInner>
            <SectionTitle animation={FadeIn} duration="1.5s">
              We have clients <span>around the world</span>
            </SectionTitle>
            <TitleDescription animation={FadeIn} delay="0.4s" duration="1.5s">
              With a team that supports global customers and partners, Mappedin
              provides proven value to all indoor spaces, regardless of
              geographic location.
            </TitleDescription>
          </HeaderContainerInner>
        </HeaderContainer>
        <MapContainer animation={FadeInBottom} delay="0.4s">
          <img src={data.file.publicURL} alt="World Map" />
          <MapLabel top={45} left={0}>
            <span>693</span>
            <span>
              North American
              <br /> Venues
            </span>
          </MapLabel>
          <MapLabel top={78} left={72}>
            <span>147</span>
            <span>
              Australian
              <br /> Venues
            </span>
          </MapLabel>
          <MapLabel top={33} left={46}>
            <span>187</span>
            <span>
              European
              <br /> Venues
            </span>
          </MapLabel>
          <MapLabel top={62} left={81}>
            <span>74</span>
            <span style={{ whiteSpace: "nowrap" }}>
              Asian Pacific
              <br /> Venues
            </span>
          </MapLabel>
          <MapLabel top={72} left={9}>
            <span>29</span>
            <span>
              South American
              <br /> Venues
            </span>
          </MapLabel>
          <MapLabel top={49} left={58}>
            <span>24</span>
            <span>
              Middle Eastern
              <br /> Venues
            </span>
          </MapLabel>
          <MapLabel top={70} left={52}>
            <span>4</span>
            <span>
              African
              <br /> Venues
            </span>
          </MapLabel>
        </MapContainer>
      </Grid>
      <SectionDivider flip />
    </Container>
  )
}

export default React.memo(ClientLocations)
